import axios from 'axios';

const BACKEND_URL =
  '';

const authConfig = () => ({
  headers: {
    Authorization:
      `Bearer ${localStorage.getItem('access_token') || ''}`,
  },
});

export const getContractorOperationsOverview = async ({
  startDate,
  endDate,
  days = 31,
} = {}) => {
  const response = await axios.get(
    `${BACKEND_URL}/api/contractor-portal/operations/overview`,
    {
      ...authConfig(),
      params: {
        days,
        ...(startDate ? { start_date: startDate } : {}),
        ...(endDate ? { end_date: endDate } : {}),
      },
    },
  );

  return response.data;
};


export const getContractorPortalOverview = async () => {
  const response = await axios.get(
    `${BACKEND_URL}/api/contractor-onboarding/contractor-portal/overview`,
    authConfig(),
  );

  return response.data;
};

// IRIS_R6_E_R5_WORKFORCE_API
export const getContractorPortalWorkforce = async () => {
  const response = await axios.get(
    `${BACKEND_URL}/api/contractor-onboarding/contractor-portal/workforce`,
    authConfig(),
  );

  return response.data;
};

export const getContractorPortalCandidate = async (
  invitationId,
) => {
  const response = await axios.get(
    `${BACKEND_URL}/api/contractor-onboarding/contractor-portal/candidates/${encodeURIComponent(invitationId)}`,
    authConfig(),
  );

  return response.data;
};

export const inviteContractorCandidate = async ({
  contractorId,
  candidateName,
  candidateEmail,
  ttlHours = 72,
}) => {
  const response = await axios.post(
    `${BACKEND_URL}/api/contractor-onboarding/contractors/${encodeURIComponent(contractorId)}/invitations/issue-and-send`,
    {
      candidate_name: candidateName || null,
      candidate_email: candidateEmail,
      ttl_hours: ttlHours,
      confirm_delivery: true,
    },
    authConfig(),
  );

  return response.data;
};
